module.exports = __webpack_public_path__ + "img/4c.2ae44cce.svg";